"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrl = void 0;
var _fixExcessiveSlashing = require("./fixExcessiveSlashing");
const queryParamsSerializer = params => {
  const searchParams = new URLSearchParams();
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => {
        if (v != null) {
          searchParams.append(key, encodeURIComponent(v.toString()));
        }
      });
    } else if (value != null) {
      searchParams.append(key, encodeURIComponent(value.toString()));
    }
  });
  return searchParams.toString();
};
const getUrl = config => {
  let requestUrl;
  if (config.url?.startsWith('http')) {
    requestUrl = new URL(config.url);
  } else if (config.baseURL?.startsWith('http')) {
    const baseURLObject = new URL(config.baseURL);
    requestUrl = new URL((0, _fixExcessiveSlashing.fixExcessiveSlashing)(`/${baseURLObject.pathname}/${config.url}`), baseURLObject.origin);
  } else {
    if (typeof window === 'undefined') {
      throw new TypeError('fetchAdapter - cannot construct URL, because request url does not have origin and no origin has been set in baseURL either');
    }
    requestUrl = new URL((0, _fixExcessiveSlashing.fixExcessiveSlashing)(`/${config.baseURL}/${config.url ?? ''}`), window.location.origin);
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- okay here
  requestUrl.search = queryParamsSerializer(config.params);
  return requestUrl.toString();
};
exports.getUrl = getUrl;
